import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainScene from './components/MainScene';
import SparkleCursor from './components/SparkleCursor'; 

function App() {


  return (
    <Router>
       <SparkleCursor />
        <Routes>
          <Route path="/" element={<MainScene />} />
        </Routes>
    </Router>
  );
}

export default App;
